import { type GetterTree } from 'vuex';

import { type IObligationState } from '@/store/obligation-module/types';

export const GET_RESPONSIBILITIES = 'getResponsibilities';

export const getters: GetterTree<IObligationState, unknown> = {
    [GET_RESPONSIBILITIES]: (_state) => {
        return _state.responsibilities;
    }
};
